import {Autocomplete, TextField} from '@mui/material';
import axios from 'axios';
import useSWR from 'swr';

const fetcher = await axios.get(`https://api.memed.com.br/v1/especialidades`);

export default function SelectMemed({onChange, name, value, ...props}) {
    const {data, error, isLoading, mutate, isValidating} = useSWR(fetcher, data => data.data.data);
    
    const options = data?.map(o => ({label: `${o.attributes.nome} (${o.attributes.grupo || 'Sem grupo'})`, id: o.id}));
    const selected = options?.find(o => o.id === value);
       
    return (
        <Autocomplete
            options={options}
            onChange={(e, value) => onChange(name, value.id)}
            value={selected}
            getOptionLabel={option => option.label}
            {...props}
            renderInput={params => <TextField {...params}  label="Especialidade MEMED" />}
        />
    );
}
